const productsData = {
  watches: [
    {
      id: 1,
      title:
        "سوار تتبع اللياقة البدنية من اونر باند 6، شاشة 1.47 بوصة AMOLED - اسود",
      image: "/images/products/watches/1.jpg",
      price: 821,
      inCart: false,
      count: 1,
      description:
        "<ul><li>الذاكرة: 128 ميجا بايت</li><li>الشاشة: 1.47 بوصة، 368 × 194 بكسل، 294 بكسل لكل بوصة، شاشة لمس كاملة، AMOLED</li><li>الوصلات: المستشعرات: مستشعر 6 محاور IMU: مسرع، جيروسكوب، معدل ضربات القلب البصري</li><li>الاتصال بالشبكات: Bluetooth 5.0 BLE</li></ul>",
    },
    {
      id: 2,
      title:
        "ساعة سمارت جي تي 2 برو مقاومة للماء بشاشة AMOLED 1.39 بوصة من هواوي - رمادي نيبيولا",
      image: "/images/products/watches/2.jpg",
      price: 4839,
      inCart: false,
      count: 1,
      description:
        "<ul><li>الذاكرة: 4 جيجابايت</li><li>بلوتوث إصدار 5.1</li><li>مقاومة للماء</li></ul>",
    },
    {
      id: 3,
      title:
        "اوكيولوس كويست 2 – سماعة الواقع الافتراضي المتقدمة الكل في واحد - 128 جيجا",
      image: "/images/products/watches/3.jpg",
      price: 9266,
      inCart: false,
      count: 1,
      description:
        "<ul><li>تصميم فريد وعصري.</li><li>مصنوع من مادة عالية الجودة</li><li>متوافق مع أجهزة متعددة</li></ul>",
    },
  ],
  tvs: [
    {
      id: 1,
      title:
        "تليفزيون سمارت ال اي دي 32 بوصة اتش دي مع ريسيفر مدمج من توشيبا، اسود - 32L5995EA",
      image: "/images/products/tvs/1.jpg",
      price: 3600,
      inCart: false,
      count: 1,
      description:
        "<ul><li>نظام التشغيل: أندرويد 9.0</li><li>قوة مكبر الصوت: 2 × 8 واط</li><li>معالجة الصورة: 8 بت</li></ul>",
    },
    {
      id: 1,
      title:
        "تليفزيون سمارت كيو ال اي دي 65 بوصة 4K الترا اتش دي بريسيفر مدمج من سامسونج، اسود - QA65Q70AAUXEG",
      image: "/images/products/tvs/2.jpg",
      price: 23974,
      inCart: false,
      count: 1,
      description:
        "<ul><li>حجم الشاشة: 65 بوصة</li><li>تليفزيون مزود بتطبيق نتفليكس ويوتيوب وتطبيقات اخرى مثبتة مسبقًا</li><li>درجة وضوح الشاشة: 3840×3160 بكسل</li></ul>",
    },
  ],
  phones: [
    {
      id: 1,
      title:
        "ابل ايفون 13 برو ماكس مع فيس تايم - 256 جيجا ، 6 جيجا رام ، الجيل الرابع ال تي اي ، سييرا بلو ، شريحة واحدة وشريحة الكترونية",
      image: "/images/products/phones/1.jpg",
      price: 25491,
      inCart: false,
      count: 1,
      description:
        "شاشة Super Retina XDR مقاس 6.7 بوصة مع تقنية ProMotion لشعور أسرع وأكثر استجابة",
    },
    {
      id: 2,
      title:
        "موبايل سامسونج جالاكسي A52s بشريحتين اتصال - ذاكرة داخلية 128 جيجا، RAM 8 جيجا، 5G، بنفسجي",
      image: "/images/products/phones/2.jpg",
      price: 7880,
      inCart: false,
      count: 1,
      description:
        "6.5 بوصة، 1080 × 2400 بيكسل، 64 ميجابيكسل، 2160 بيكسل، 8 جيجا RAM، معالج سنابدراجون، 778 جيجا، 5G، بطارية ليثيوم بوليمر 4500 مللي أمبير في الساعة",
    },
    {
      id: 3,
      title:
        "موبايل شاومي 11T بشريحتين اتصال، 6.67 بوصة، 256 جيجابايت، RAM 8 جيجابايت، 5G، رمادي ميتيورايت",
      image: "/images/products/phones/3.jpg",
      price: 8888,
      inCart: false,
      count: 1,
      description:
        "موبايل شاومي 11T بشريحتين اتصال، 6.67 بوصة، 256 جيجابايت، RAM 8 جيجابايت، 5G، رمادي ميتيورايت",
    },
    {
      id: 4,
      title:
        "موبايل رينو 6 بشريحتي اتصال بذاكرة داخلية 8 جيجابايت ورام 128 جيجابايت وشبكة 4G LTE",
      image: "/images/products/phones/4.jpg",
      price: 7289,
      inCart: false,
      count: 1,
      description:
        "موبايل اوبو رينو 6 بمساحة تخزين داخلية تصل إلى 8 جيجابايت + 128 جيجابايت لحفظ جميع ذكرياتك وفي حال كانت المساحة غير كافية، يُمكنك الاستمتاع بقدرات التوسع لذاكرة رام المدمجة به، كما يتميز هذا الموبايل بطبقة نهائية مقاومة لبصمات الأصابع لمظهر جمالي جذّاب. كما أنه مدمج بخاصية لقطات الفلاش السريعة التي تعمل بمستشعر محرك درجة صفاء اللون الحصري ومستشعر درجة الحرارة الحصري من اوبو، مما يسمح للموبايل بدأ التركيز تلقائيًا بمجرد بدء تشغيل الكاميرا.",
    },
    {
      id: 5,
      title:
        "هواوي Y5p بشريحتي اتصال - 32 جيجا، 2 جيجا رام، شبكة الجيل الرابع ال تي اي - اسود ميدنايت",
      image: "/images/products/phones/5.jpg",
      price: 2321,
      inCart: false,
      count: 1,
      description:
        "اللون اسود , دقه الكاميرا 8 ميجا بيكسل , سعه تخزين 32جيجا بايت",
    },
  ],
  labtops: [
    {
      id: 1,
      title:
        "لاب توب ديل للالعاب G5 SE 5505، رايزن 5 4600 هرتز 6 كور، Ram 16 جيجا، منفذ ملحقات اضافية 512 جيجا ذاكرة اس اس دي لوحة مفاتيح باضاءة خلفية معالج رسومات 5600 ويندوز 10 15.6 بوصة فل اتش دي، فضي سوبرفونا",
      image: "/images/products/labtops/1.jpg",
      price: 19807,
      inCart: false,
      count: 1,
      description:
        "<ul><li>معالج ايه ام دي الجيل الرابع رايزن 5 4600 هرتز (6 كور، 3.0 جيجاهيرتز حتى 4.0 جيجاهرتز، ذاكرة تخزين مؤقتة 8 ميجابايت)</li><li>الذاكرة والتخزين: - ذاكرة DDR4 8 جيجابايت، منفذ الملحقات الإضافية السريع 512 جيجابايت اس اس دي</li><li>شاشة العرض :- شاشة 15.6 بوصة عالية الدقة (1920 × 1080) مضادة للوهج</li></ul>",
    },
    {
      id: 2,
      title:
        "لاب توب اتش بي بافيليون 15-dk2075ne انتل كور i7-11370H الجيل 11 رام 16 جيجا HDD 1 تيرا SSD 256 جيجا انفيديا جي فورس RTX 3050 4 جيجا رسومات GDDR6، 15.6 بوصة FHD (1920×1080)، IPS 144 هرتز، دوس اسود",
      image: "/images/products/labtops/2.jpg",
      price: 23755,
      inCart: false,
      count: 1,
      description:
        "لاب توب اتش بي بافيليون 15-dk2075ne انتل كور i7-11370H الجيل 11 رام 16 جيجا HDD 1 تيرا SSD 256 جيجا انفيديا جي فورس RTX 3050 4 جيجا رسومات GDDR6، 15.6 بوصة FHD (1920×1080)، IPS 144 هرتز، دوس اسود",
    },
    {
      id: 3,
      title:
        "لاب توب ديل G15 15-5510 للجيمنج - انتل كور i5-10200H، 8 جيجا رام 512 جيجا ssd نفيديا جيفورس GTX1650 4 جيجا GDDR6 جرافيكس، 15.6 بوصةفل اتش دي اي بي اس 120 هرتز، كيبورد باضاءة خلفية اوبنتو - رمادي غامق",
      image: "/images/products/labtops/3.jpg",
      price: 15150,
      inCart: false,
      count: 1,
      description: "",
    },
    {
      id: 4,
      title:
        "لاب توب العاب فيكتوس 16، نيفيديا جيفورس ار تي اكس، معالج 3050 ايه ام دي رايزن 5 5600H، 8 جيجا رام، اس اس دي 512 جيجا، شاشة 16.1 بوصة بتقنية FHD، ويندوز هوم 10، كيبورد باضاءة خلفية، (16-e0010nr، 2021)",
      image: "/images/products/labtops/4.jpg",
      price: 18330,
      inCart: false,
      count: 1,
      description:
        "<ul><li>مصمم للألعاب - يحتوي لاب توب الألعاب فيكتوس من اتش بي مقاس 16.1 بوصة على ما تحتاج إليه للعب: معالج ايه ام دي قوي، رسومات رائعة، نظام تبريد مطوّر (1)، شاشة عالية الدقة، موزع ألعاب اومين.</li><li>مصمم من أجل مستقبل مستدام - صُمم مع مراعاة البيئة في الاعتبار، وقد صُمم اللاب توب الخاص بك من بلاستيك المحيط (13) (14)، ويتم شحنه في عبوة قابلة لإعادة التدوير بنسبة 100% (15)، ومعتمد من انيرجي ستار (16)، وهو نظام ابيات سيلفر مسجل (17).</li><li>رسومات مدعومة من ار تي اكس - استمتع ببصريات مذهلة وغامرة، بفضل بنية نيفيديا جيفورس ار تي اكس 3050 الحائزة على جائزة مع 4 جيجابايت من الذاكرة المخصصة (2).</li><li>ألعب أينما تريد - خذ هذا اللاب توب من اتش بي إلى الخارج أو معك أثناء التنقل حيث تضمن اللوحة المضادة للوهج رؤية كل تفاصيل فل اتش دي (1920 × 1080)، اي بي اس، شاشة بحواف ميكرو (3).<li>الذاكرة والتخزين - مع 8 جيجا رام، ستحصل على دفعة من استجابة النظام ومعدلات محسنة للإطار أثناء اللعب؛ بالإضافة إلى ذلك، فإن وحدة التخزين منفذ الملحقات السريعة M.2 وقرص تخزين في الحالة الصلبة SSD سعة 512 جيجابايت تمنح اللاب توب أوقات تحميل أقصر وتشغيل أسرع الذي يتوق له كل لاعب (6) (7).</li></ul>",
    },
  ],
  headphones: [
    {
      id: 1,
      title: "سماعات ابل ايربودز برو، ابيض - MWP22ZE/A",
      image: "/images/products/headphones/1.jpg",
      price: 4949,
      inCart: false,
      count: 1,
      description:
        "<ul><li>خاصية إلغاء الضوضاء النشطة</li><li>وضع الشفافية</li><li>مقاومة للعرق والماء (بتصنيف اي بي اكس 4)</li><li>شحن سريع في الجراب نفس</li></ul>",
    },
    {
      id: 2,
      title:
        "سماعات رأس للالعاب للبنات من اونيكوما K9 بإضاءة RGB ونظام صوت محيطي متعدد المنصات مع اذان قطة قابلة للفصل، بينك",
      image: "/images/products/headphones/2.jpg",
      price: 450,
      inCart: false,
      count: 1,
      description:
        "<ul><li>صُممت سلسلة أذن القطة من اونيكوما K9 بشكل فريد لجميع اللاعبات الموجودين هناك. أضواء LED رياضية ملونة</li><li>ميكروفون مرن وقابل للسحب</li><li> إضاءة LED بألوان RGB ساطعة (يمكن إيقاف تشغيلها)</li></ul>",
    },
    {
      id: 3,
      title:
        "سماعات رأس سلكية للالعاب موديل زيوس H510 من ريدراجون - صوت محيطي 7.1 - وسائد اذن ميموري فوم - مشغل 53 ملم - ميكروفون قابل للفصل - متوافق مع الكمبيوتر، بلاي ستيشن 4/3، Xbox one/سلسلة X، NS",
      image: "/images/products/headphones/3.jpg",
      price: 949,
      inCart: false,
      count: 1,
      description:
        "<ul><li>صوت واضح بدقة - استمتع بجودة الصوت الواضحة الحقيقية بدون فقد مع تقنية الصوت المحيطي 7.1، مما يخلق مجال من الانغماس في أي مكان في ساحة الألعاب، والاستماع إلى الحفلات الموسيقية النابضة بالحياة أو في غرفة الدردشة توفر مشغلات 53 ملم نطاقًا تردديًا أوسع، وحقول صوت أكثر ثراء، ودقة أعلى وصوت فائق الدقة.</li><li>قابلة للتعديل ومريحة - طوق الرأس القابل للتعديل بشكل مريح مع إطار معدن متين وخفيف الوزن سوف يحرر رأسك من العبء الإضافية عند اللعب أو الاستماع إلى الموسيقى. أجود أنواع الجلد مع حشو من الميموري فوم الممتاز يعطي التهوية لأذنيك ويحافظ عليها جافة وبادرة. لا داعي للقلق، حتى بعد ساعات من الارتداء لن تشعر سوى بالراحة.</li><li>تحكم كامل - يتميز جهاز ريدراجون H510 بأزرار تحكم مستقلة في الكابل مع إمكانية ضبط مستوى الصوت +/-، التشغيل والإيقاف، تشغيل/إيقاف الميكروفون. يمكن تعديل جميع الإعدادات بيد واحدة لتلبية الاحتياجات المختلفة في أي حالة، تأكد من أنك تستطيع اللعب جيدا حتى في الألعاب المكثفة.</li></ul>",
    },
  ],
};
export default productsData;
